import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useFinalizePayment from "../../store/Mutations/organisation-useFinalizePayment";
import Loading from "../../components/Loading/Loading";
import { logCustomEvent } from "../../utils/analytics";
import { hasMarketingConsent } from "../../utils/consent";

const Success = () => {
  const params = useSearchParams();
  const token = params?.[0].get("token");
  const navigate = useNavigate();
  const { mutate } = useFinalizePayment({
    onSuccess: (data) => {
      // Enhanced conversions ship the email to Google/Meta — marketing consent only.
      if (data.b2bAdmin?.email && hasMarketingConsent()) {
        window.enhanced_conversions = {
          email: data.b2bAdmin.email,
        };
      }
      if (process.env.REACT_APP_ENV === "prod") {
        logCustomEvent("PremiumBusinessReg(WEB)Prod", {
          method: "Credit Card",
        });
      }

      navigate("/welcome");
    },
  });
  useEffect(() => {
    if (token) {
      mutate({
        token,
        success: true,
      });
    }
  }, [token, mutate]);

  return <Loading />;
};

export default Success;
